import React from "react";
import "./RequisitionProcessResult.css";
import { supplierMinimumMessage } from "./popups/documentPopupMessages";

export default function RequisitionProcessResult({ createdCount, orders = [], languageId = "en" }) {
  const text = (es, en, ca) => languageId === "es" ? es : languageId === "ca" ? ca : en;
  const sent = orders.filter((order) => order.sent === true).length;
  const pendingCount = Math.max(orders.length, createdCount) - sent;
  const needsAttention = orders.filter((order) => order.sent !== true || order.code === "PO_SEND_RECORD_FAILED");
  const checkStatus = text("Consulta el estado del pedido.", "Check the order status.", "Consulta l’estat de la comanda.");
  const draft = text("Borrador sin enviar. Revísalo y preséntalo.", "Unsent draft. Review and submit it.", "Esborrany sense enviar. Revisa’l i presenta’l.");
  const review = text("Revisa y presenta el pedido.", "Review and submit the order.", "Revisa i presenta la comanda.");

  function issue(order) {
    if (order.minimum_order) return supplierMinimumMessage(order.minimum_order, languageId);
    if (order.code === "SUPPLIER_EMAIL_MISSING")
      return text("Añade el correo del proveedor.", "Add the supplier’s email address.", "Afegeix el correu del proveïdor.");
    if (order.code === "SUPPLIER_INACTIVE")
      return text("Selecciona un proveedor activo.", "Select an active supplier.", "Selecciona un proveïdor actiu.");
    if (order.code === "PO_APPROVER_UNAVAILABLE" || order.decision_source === "unavailable_approvers")
      return text("Sin aprobador disponible. Abre el pedido y preséntalo manualmente.", "No approver available. Open the order and submit it manually.", "No hi ha cap aprovador disponible. Obre la comanda i presenta-la manualment.");
    if (order.reason === "approval_pending" || order.reason === "approval_required")
      return text("El pedido requiere aprobación.", "The order requires approval.", "La comanda requereix aprovació.");
    if (order.code === "PO_REVIEW_REQUIRED" || order.reason === "procurement_review_required")
      return review;
    return null;
  }

  function describe(order) {
    if (order.sent === true) return { message: text("Correo aceptado. Falta registrar el envío en el pedido. No lo reenvíes.",
      "Email accepted. The send still needs to be recorded on the order. Do not resend.", "Correu acceptat. Falta registrar l’enviament a la comanda. No la reenviïs.") };
    const cause = issue(order);
    const detail = !cause && order.code !== "PO_REVIEW_ZERO_PRICE_REASON_REQUIRED" ? order.error : null;
    switch (order.delivery_state) {
      case "failed":
        return { message: text("No se pudo enviar el correo.", "The email could not be sent.", "No s’ha pogut enviar el correu."), detail };
      case "uncertain":
        return { message: text("El correo pudo salir. Compruébalo con el proveedor antes de reenviar.", "The email may have been sent. Check with the supplier before resending.", "El correu pot haver sortit. Confirma-ho amb el proveïdor abans de reenviar-lo."), detail };
      case "not_attempted": {
        const message = text("No se intentó el envío.", "Sending was not attempted.", "No s’ha intentat l’enviament.");
        return { message: cause ? `${message} ${cause}` : message, detail };
      }
      default:
        return { message: cause || (order.status === "draft" ? draft : order.review_required ? review : checkStatus), detail };
    }
  }

  return <div className="rq-process-result">
    <p>{createdCount > 0
      ? text(`${createdCount} ${createdCount === 1 ? "pedido creado" : "pedidos creados"}`, `${createdCount} ${createdCount === 1 ? "order created" : "orders created"}`, `${createdCount} ${createdCount === 1 ? "comanda creada" : "comandes creades"}`)
      : text("Solicitud procesada", "Requisition processed", "Sol·licitud processada")}</p>
    <dl className="rq-process-result__counts">
      <div><dt>{text("Enviados", "Sent", "Enviats")}</dt><dd>{sent}</dd></div>
      {pendingCount > 0 && <div><dt>{text("Pendientes", "Pending", "Pendents")}</dt><dd>{pendingCount}</dd></div>}
    </dl>
    {(needsAttention.length > 0 || pendingCount > 0) && <>
      <h3>{text("Por resolver en Pedidos de compra", "To resolve in Purchase Orders", "Per resoldre a Comandes de compra")}</h3>
      {needsAttention.length > 0 ? <ul>{needsAttention.map((order, index) => {
        const { message, detail } = describe(order);
        return <li key={order.order_id || index}>
          <strong>{order.order_code || (order.order_id ? `#${order.order_id}` : text("Pedido", "Order", "Comanda"))}</strong>
          <span>{message}</span>
          {detail && <details><summary>{text("Ver detalle", "View details", "Veure detall")}</summary><p>{detail}</p></details>}
        </li>;
      })}</ul> : <p>{checkStatus}</p>}
    </>}
  </div>;
}
